import type { FieldErrorFieldsFragment } from '@/gql/reviews'

export function mapReviewsServerErrors<T>(errors: FieldErrorFieldsFragment[]): Partial<Record<keyof T, string>> {
  return errors.reduce(
    (acc, error) => {
      if (error.field) {
        acc[error.field as keyof T] = error.message
      }
      return acc
    },
    {} as Partial<Record<keyof T, string>>,
  )
}
